// Configuration utility for environment variables and settings
export const Config = {
  // Get Swagger API URL based on current domain
  getSwaggerApiUrl: (): string => {
    const origin = window.location.origin;
    
    // Production environment
    if (origin === 'https://s2s-help-overview.azurewebsites.net') {
      return 'https://teamsmanagerprod.azurefd.net/swagger/index.html';
    }
    
    // Test environment (localhost, test domains, etc.)
    return 'https://teamsmanagertest.azurefd.net/swagger/index.html';
  },
  
  // Get full Swagger API docs URL with theme parameter
  getFullSwaggerApiUrl: (theme: string = 'light'): string => {
    const baseUrl = Config.getSwaggerApiUrl();
    return `${baseUrl}?theme=${theme}`;
  }
}; 